export const STATUS_LABEL_CLASS: { [key: string]: string } = {
  draft: 'rnpl-status-lbl--pending',
  template: 'rnpl-status-lbl--pending',
  open: 'rnpl-status-lbl--active',
  active: 'rnpl-status-lbl--active',
  editing: 'rnpl-status-lbl--editing',
  reported: 'rnpl-status-lbl--editing',
  overdue: 'rnpl-status-lbl--warning',
  corrupted: 'rnpl-status-lbl--warning',
  paid: 'rnpl-status-lbl--positive',
  canceled: 'rnpl-status-lbl--negative',
  deleted: 'rnpl-status-lbl--deleted',
  accepted: 'rnpl-status-lbl--positive',
  declined: 'rnpl-status-lbl--negative',
  completed: 'rnpl-status-lbl--positive',
  packing: 'rnpl-status-lbl--active',
  packed_up: 'rnpl-status-lbl--active',
  shipped: 'rnpl-status-lbl--positive',
  paused: 'rnpl-status-lbl--pending',
  shortage: 'rnpl-status-lbl--warning',
  pending: 'rnpl-status-lbl--pending',
  booked: 'rnpl-status-lbl--positive',
};
